<template>
    <div class="all-section-area">
        <MainHeader />
        <main class="main-content-wrap">
            <PageTitle mainTitle="My Devices" pageTitle="Delete Files" />
            <DeleteFilesDevices />
            <div class="flex-grow-1"></div>
            <FooterArea />
        </main>
    </div>
</template>

<script>
import MainHeader from '../Layouts/MainHeader'
import PageTitle from '../Common/PageTitle'
import DeleteFilesDevices from '../DeleteFiles/DeleteFilesDevices'
import FooterArea from '../Layouts/FooterArea'

export default {
    name: 'DeleteFilesPage',
    components: {
        MainHeader,
        PageTitle,
        DeleteFilesDevices,
        FooterArea,
    },
    mounted () {
        document.body.classList.add('body-bg-f8faff')
    },
}
</script>